import { render, staticRenderFns } from "./car_column.vue?vue&type=template&id=614ddede&"
import script from "./car_column.vue?vue&type=script&lang=js&"
export * from "./car_column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports